<template>
  <input
    v-escape-blur
    @keyup.enter="defocus"
    :class="[
      $data.class,
      {
        isNumberType,
        'font-serif text-white max-md:leading-normal': isNumberType,
        'w-full leading-tighter': !isNumberType,
      },
    ]"
    :value="value"
    ref="input"
    @input="() => debouncedNotify()"
    @blur="notify"
  />
</template>

<script>
import { debounce } from 'lodash-es'
import EscapeBlur from '@/directives/EscapeBlur'

export default {
  directives: {
    EscapeBlur,
  },

  props: {
    focus: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      required: true,
      default: ``,
    },
  },

  computed: {
    isNumberType() {
      return this.$attrs.type === `number`
    },

    withDefault() {
      return this.isNumberType && isNaN(this.value) ? 0 : this.value
    },
  },

  methods: {
    notify() {
      this.$emit(`input`, this.refValue())
    },

    refValue() {
      return this.isNumberType
        ? this.$refs[`input`].value * 1
        : this.$refs[`input`].value
    },

    defocus() {
      this.$refs[`input`].blur()
      return false
    },
  },

  created() {
    this.debouncedNotify = debounce(this.notify, 1000)
  },

  mounted: function() {
    if (this.focus) this.$el.select()
  },
}
</script>

<style lang="postcss" scoped>
input {
  font-weight: inherit;
}

.isNumberType {
  transform-origin: 100% 40%;
  transition: all 0.08s;

  &::-webkit-inner-spin-button {
    appearance: none;
  }

  &:hover,
  &:focus {
    transform: var(--scale);
  }
}
</style>
